"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    body: '',
    args: [],
    thisVars: [],
    localVars: [],
};
//# sourceMappingURL=EmptyProc.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ndarray-ops-typed/lib/EmptyProc.js
 ** module id = 731
 ** module chunks = 0
 **/